import { createContext } from 'react';
import { ITransferContext } from './types';

const TransferContext = createContext<ITransferContext>({} as ITransferContext);

export default TransferContext;
